const {
    useEffect,
    useState
} = require('react');
const {
    filterInKeys,
    filterOutKeys,
    formatSimilarityText,
    makeSimilarityText
} = require('utils/makeUsersSimilarityText');
const { makeRandomInterestsText } = require('utils/makeRandomInterestsText');
const { USER_ROLE_IDS } = require('utils/constants');

const internals = {};

internals.studentSimilarityTypes = [
    'majors',
    'transfer',
    'online'
];

internals.formatSummary = (baseText, studentText, peerName, isParent) => {

    let summary = baseText ? `${baseText} ` : '';

    if (studentText) {
        summary += isParent
            ? `Your students${studentText}`
            : `You and ${peerName}'s student ${studentText}`;
    }

    return formatSimilarityText(summary);
};

internals.getSimilarityText = ({ categories, userDetails }) => {

    const { similarities, user } = userDetails;
    const isParent = USER_ROLE_IDS.PARENT.includes(user.role.id);
    const hasSimilarities = [
        similarities?.classes,
        similarities?.interests,
        similarities?.passionInterests,
        similarities?.majors
    ].some((items) => !!items?.length);

    if (!hasSimilarities) {
        if (!userDetails.interests || !user.firstName) {
            return '';
        }

        return makeRandomInterestsText({
            interests: { interests: userDetails.interests },
            categories,
            userName: user.firstName,
            isMe: false
        });
    }

    let baseText;
    let studentText;

    if (isParent) {
        const { baseSimilarities, classSimilarities } = makeSimilarityText({
            similarities: filterOutKeys(similarities, internals.studentSimilarityTypes)
        });

        if (baseSimilarities || classSimilarities) {
            baseText = `${baseSimilarities ?? ''} ${classSimilarities ?? ''}`;
        }

        const { baseSimilarities: studentBaseSimilarities } = makeSimilarityText({
            similarities: filterInKeys(similarities, internals.studentSimilarityTypes),
            areStartTxt: ' are'
        });

        studentText = studentBaseSimilarities;
    }
    else {
        const { baseSimilarities, classSimilarities } = makeSimilarityText({ similarities });

        if (baseSimilarities || classSimilarities) {
            baseText = `${baseSimilarities ?? ''} ${classSimilarities ?? ''}`;
        }
    }

    return internals.formatSummary(baseText, studentText, user.firstName, isParent);
};

const useDirectMessageSimilarityText = ({
    categories,
    dependenciesReady,
    userDetails,
    variant
}) => {

    const [similarityText, setSimilarityText] = useState('');

    useEffect(() => {

        if (variant !== 'dm' || !dependenciesReady || !userDetails?.user?.role) {
            setSimilarityText('');
            return;
        }

        setSimilarityText(internals.getSimilarityText({ categories, userDetails }));
    }, [categories, dependenciesReady, userDetails, variant]);

    return similarityText;
};

exports.useDirectMessageSimilarityText = useDirectMessageSimilarityText;

if (process.env.NODE_ENV === 'test') {
    exports._internals = internals;
}
